module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-col"
  }, [_c('p', [_vm._v("\n    NEWS "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.obj.date))])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.obj.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "excerpt",
    domProps: {
      "innerHTML": _vm._s(_vm.obj.excerpt)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "view-more",
    on: {
      "click": _vm.viewMore
    }
  }, [_c('b', [_vm._v("View more >")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a7b63c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SlideNews.vue
// module id = 286
// module chunks = 0